export enum SelectedZonesEnum{
    SPEED,
    HEARTRATE
}
